var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93,13H89V10H19V3H93Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,13h4V65H89Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,20H85V17H15V10H89Z",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,20h4V72H85Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,27H81V24H11V17H85Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,27h4V79H81Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,34H77V31H7V24H81Z",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,34h4V86H77Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,31H77V41H3Z",
    fill: "#63b2b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,41H77V93H3Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,46H44V76H8Z",
    fill: "#e6646e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(16 51)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,66V56l10,5Z",
    fill: "#e6646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,46H59V57H49Z",
    fill: "#f68250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,46H72V57H59Z",
    fill: "#f9be3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,61H59V72H49Z",
    fill: "#f68250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,61H72V72H59Z",
    fill: "#f9be3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,76H59V87H49Z",
    fill: "#f68250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,76H72V87H59Z",
    fill: "#f9be3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,37H39a1,1,0,0,1,0-2H73a1,1,0,0,1,0,2Z",
    fill: "#50a3ab"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(15 35)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(11 35)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(7 35)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,81H8a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z",
    fill: "#8c645a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,81H16a1,1,0,0,1,0-2H44a1,1,0,0,1,0,2Z",
    fill: "#8c645a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,85H8a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z",
    fill: "#8c645a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,85H16a1,1,0,0,1,0-2H44a1,1,0,0,1,0,2Z",
    fill: "#8c645a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,89H8a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z",
    fill: "#8c645a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,89H16a1,1,0,0,1,0-2H44a1,1,0,0,1,0,2Z",
    fill: "#8c645a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialsicon);
export default __webpack_public_path__ + "static/media/tutorialsicon.fdbe4efbb27a7ce8b575042abc0a5262.svg";
export { ForwardRef as ReactComponent };